module.exports = __webpack_public_path__ + "resources/img/img_awesome_secure_trust1.514aeb76b50e5502a1c0c915e3eedec3.png";